<template>
    <div class="collapse-content-container">
        <div class="content-item" v-for="(value, name, index) in data" :key="index">
            <div class="content-item-name">{{name}}</div>
            <div class="content-item-value">{{value}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
    }
}
</script>

<style lang="less" scoped>
.collapse-content-container {
    .content-item {
        display: flex;
        flex-direction: row;
        
        .content-item-name {
            .w(144);
            display: flex;
            align-items: center;
            padding-left: 24rem;
            min-height: 48rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            border-right:  1px solid rgba(0, 0, 0, 0.06);
        }

        .content-item-value {
            .w(355);
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 24rem;
            min-height: 48rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        }
    }
}
</style>